import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    details: {
        id: 'cards.actions.details',
        defaultMessage: 'Details',
    },
})
